import SftpSettings from "./Sftp";

export default SftpSettings;
